import { Text } from '@chakra-ui/react'
import * as React from 'react'
import { useColor } from '../../../theme'
import { IFormValidationProps } from '../hooks'

interface ISuccessMessageProps extends Pick<IFormValidationProps, 'isDisabled'> {
  children?: React.ReactNode,
  'data-testid'?: string
}

export const SuccessMessage: React.FC<ISuccessMessageProps> = ({
  isDisabled,
  children,
}) => {
  const validColor = useColor({ nuance: 'green', palette: 'colors' })

  return (
    <Text
      as="span"
      color={validColor}
      data-testid="form-component-success-message"
      fontSize="sm"
      marginBottom="0.3rem"
      opacity={isDisabled ? 0.25 : 1}>
      {children}
    </Text>
  )
}
